<div class="exception-list">
    <div class="content">
            <res-document-list #exceptionListGrid [responseCallback]="responseCallback"></res-document-list>
    </div>
</div>